import { TextField } from '@mui/material'
import { addMissingZero } from '../../../utility'
import './Input.scss'
import NumberFormat from 'react-number-format'
import { forwardRef } from 'react'
import { useSelector } from 'react-redux'

const CurrencyFormatter = forwardRef((props, ref) => {
  const { onChange, ...other } = props
  const translations = useSelector((state) => state.translations)

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => onChange({ target: { value: values.value } })}
      thousandSeparator={'.'}
      decimalSeparator={','}
      isNumericString
      suffix={translations['currency.string']}
    />
  )
})

const KilometerFormatter = forwardRef((props, ref) => {
  const { onChange, ...other } = props
  const translations = useSelector((state) => state.translations)

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => onChange({ target: { value: values.value } })}
      thousandSeparator={'.'}
      decimalSeparator={','}
      isNumericString
      suffix={translations['kilometer']}
    />
  )
})

const Input = (props) => {
  const { type, value, onChange, placeholder, variant } = props

  const propIsMissing = () => {
    const requiredProps = ['value', 'onChange']
    return requiredProps.reduce((acc, prop) => (acc === true ? true : props[prop] === undefined), false)
  }

  const getValue = () => {
    // this means the date is provided by the database and has to be transformed into yyyy-MM-dd
    if (type === 'date' && value && value.endsWith('Z')) {
      const date = new Date(value)
      return `${date.getFullYear()}-${addMissingZero(date.getMonth() + 1)}-${addMissingZero(date.getDate())}`
    }
    return value || ''
  }
  if (propIsMissing()) return <></>
  const additionalProps = {}
  if (type === 'currency') {
    additionalProps.inputComponent = CurrencyFormatter
  } else if (type === 'kilometer') {
    additionalProps.inputComponent = KilometerFormatter
  }
  return (
    <TextField
      className="custom-MUI-input"
      type={type || 'text'}
      value={getValue()}
      onChange={(e) => onChange(e.target.value)}
      label={placeholder}
      InputProps={additionalProps}
      variant={variant ? variant : 'filled'}
      fullWidth={true}
    />
  )
}

export default Input
